import { CLOUDINARY_INTEL_BASE_URL } from "@utils/enum";
import { handleCopy } from "@helpers/profileHelper";
import moment from "moment";
import styles from "../../AddressBook.module.scss";
import { useState, useEffect } from "react";

const SectionTable = ({ data, keyName, companyId, handleCheckboxChange, selectedEmails, selectedPhones }) => {
  const [tableData, setTableData] = useState(data);

  useEffect(() => {
    setTableData([...data]);
  }, [data, selectedEmails, selectedPhones]);

  return (
    <div id={"tablelocate" + keyName} className={`d-flex flex-column ${styles.section_table}`}>
      {tableData.map((item) => {
        return (
          <div key={item.contact_value + item.created_at} className={`${styles.row_data} d-flex justify-content-between align-items-center`}>
            <div>
              <div className={styles.contact_data}>
                <input type="checkbox" className="form-check-input position-relative mr-2 ml-0" name={keyName} checked={keyName === "email" ? selectedEmails.includes(item.contact_value + companyId) : selectedPhones.includes(item.contact_value + companyId)} onChange={(e) => handleCheckboxChange(e, item, companyId)} />
                {`${item.contact_value.toLowerCase()} ${item.name ? ` (${item.name}) ` : ""}`}
                <img src={`${CLOUDINARY_INTEL_BASE_URL}/v1709185641/intel/icons/hdg1qqouwpmldojxnmwh.svg`} className={`cursor-pointer`} onClick={() => handleCopy(`${keyName === "email" ? item.contact_value?.toLowerCase() : item.contact_value} ${item.name ? ` (${item.name}) ` : ""}`)} />
              </div>
              <div className={styles.contact_date}>Added on {moment(item.created_at).format("MMM DD, YYYY")}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SectionTable;
